import axios from './../axios/index.js'

let api = process.env.API_HOST;

const actions = {
	//发送验证码
	sendMessageByPhoneAndType({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'user/sendMessageByPhoneAndType?phone=' + obj.phone + '&messageType=' + obj.messageType, {
				headers: {'content-type': "application/x-www-form-urlencoded"}
			}).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//登录
	login({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'user/login', obj, {
				headers: {'content-type': "application/x-www-form-urlencoded"}
			}).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//个人主页信息
	findUserInfo({commit}) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'user/userInfo').then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//获取列表页分类数据
	findAllNavigationCategory({commit}) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'application/action/findAllNavigationCategory').then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},
  //获取列表页分类数据
  findNewsList({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(api + 'news/h5/list').then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
    });
  },
  findNewsDetails({commit},id){
    return new Promise((resolve, reject) => {
      axios.get(api + 'news', {
        params: {
          newsId: id,
        }
      }).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
    });
  },
  searchByMultipleKeywords({commit},keyword){
    return new Promise((resolve, reject) => {
      axios.post(api + 'products/searchByMultipleKeywords?keywords=' + keyword).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
    });
  },
  getHtml({commit},url){
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
    });
  },

	//获取所有商品
	productSearch({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'products/search?pageNum=' + obj.pageNum + '&pageSize=' + obj.pageSize + '&sort=' + obj.sort + '&order=' + obj.order, obj).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//获取详情页数据
	findDetailsByProductId({commit}, id) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'products/details/' + id).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//获取列表页轮播图数据
	findAllSwipeImage({commit}, typeId) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'swipeImages/findByType?type=' + typeId).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//搜索
	productSearchByText({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'products/searchByText?pageNum=' + obj.pageNum + '&pageSize=' + obj.pageSize + '&sort=' + obj.sort + '&order=' + obj.order, obj).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//商品购买信息
	findBuyerOrderPreview({commit}, obj) {
		return new Promise((resolve, reject) => {
			let apiStr = '';
			apiStr = 'order/buyerOrderPreview?productId=' + obj.productId + '&isUseCashCoupon=' + obj.isUseCashCoupon;
			axios.post(api + apiStr).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//支付订单
	payProductOrder({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'pay/alipay', obj, {
				headers: {'content-type': "application/x-www-form-urlencoded"}
			}).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

  payServerProductOrder({commit}, id) {
    return new Promise((resolve, reject) => {
      axios.post(api + 'pay/serverProduct?id='+id).then((response) => {
        resolve(response);
      }).catch((response) => {
        reject(response);
      });
    });
  },

	//查询所有动态数据 --最近
	findLatestPosts({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'userPost/findLatestPosts', {
				params: {
					pageNum: obj.pageNum,
					pageSize: obj.pageSize
				}
			}).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	findUserPostById({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.get(api + 'userPost/findUserPostById', {
				params: {
					id: obj.id,
					pageNum: obj.pageNum,
					pageSize: obj.pageSize
				}
			}).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//用户动态上传
	publicationTrends({commit}, obj) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'userPost', obj).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},

	//用户删除动态
	deleteUserPost({commit}, id) {
		return new Promise((resolve, reject) => {
			axios.post(api + 'userPost/delete/' + id).then((response) => {
				resolve(response);
			}).catch((response) => {
				reject(response);
			});
		});
	},
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js